// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1327":"46b44b04260db7e4","2469":"0ea2db96fd7cd652"}[chunkId] + ".css";
};